export const TAB_INDEX = {
  ENABLED: 0,
  DISABLED: -1,
};
